// extracted by mini-css-extract-plugin
export default {"gate":"WdQD7Iyv","card":"R6nHUb9u","dark":"dqPv_dHs","desc":"HxJJHXEY","widgetWrap":"e6yk16pQ","status":"xnGQPlvM","error":"sfqMlpEr","retry":"PP9hIpLE"};